let cachedBlob: Blob | null = null;

export const BlobCache = {
  set(blob: Blob) {
    cachedBlob = blob;
  },
  get(): Blob | null {
    return cachedBlob;
  },
  clear() {
    cachedBlob = null;
  },
};
